import { render, staticRenderFns } from "./Patcher.vue?vue&type=template&id=635054b3&scoped=true&"
import script from "./Patcher.vue?vue&type=script&lang=js&"
export * from "./Patcher.vue?vue&type=script&lang=js&"
import style0 from "./Patcher.vue?vue&type=style&index=0&id=635054b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635054b3",
  null
  
)

export default component.exports